import { apiClient } from './api';
import { ApiResponse } from '@/types';

export interface WalletTopupRequest {
  amount: number;
}

export interface WalletTopupResponse {
  paymentId: string;
  redirectUrl: string;
  status: 'pending' | 'succeeded' | 'failed';
}

export interface WalletTopupStatusResponse {
  paymentId: string;
  status: 'pending' | 'succeeded' | 'failed';
  amount: number;
}

export const walletApi = {
  async createTopup(amount: number): Promise<ApiResponse<WalletTopupResponse>> {
    return apiClient.post<WalletTopupResponse>('/wallet/topup/', { amount });
  },

  async getTopupStatus(
    paymentId: string
  ): Promise<ApiResponse<WalletTopupStatusResponse>> {
    return apiClient.get<WalletTopupStatusResponse>(
      `/wallet/topup/${paymentId}/`
    );
  },
};
